import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const calendarProductionWorkOrdersQueryAtom = createQueryAtomFactory(
  'calendar.productionWorkOrders',
  (params: { fromDate: string; toDate: string; facilityId?: string }) => {
    const filter: Record<string, unknown> = {
      fromScheduledStartDate: `${params.fromDate}T00:00:00Z`,
      toScheduledStartDate: `${params.toDate}T23:59:59Z`,
    };

    if (params.facilityId) {
      filter.facilityIds = [params.facilityId];
    }

    return {
      workOrders: {
        __args: {
          filter,
          pagination: {
            limit: 500,
            offset: 0,
          },
        },
        entries: {
          id: true,
          workOrderNumber: true,
          status: true,
          scheduledStartDate: true,
          scheduledEndDate: true,
          facilityId: true,
          facility: {
            id: true,
            facilityName: true,
          },
        },
        page: {
          total: true,
        },
      },
    };
  },
);
